import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getAdminToken, adminLoginFromSession, clearAdminToken } from "../utils/adminAuth";
import AdminHomepageImages from "../components/AdminHomepageImages";
import AdminAdLeads from "../components/AdminAdLeads";
import AdminAdSegments from "../components/AdminAdSegments";
import AdminBecomeAgent from "../components/AdminBecomeAgent";
import AdminServiceInquiries from "../components/AdminServiceInquiries";
import AdminPageManagement from "../components/AdminPageManagement";
import AdminSubdomains from "../components/AdminSubdomains";
import AdminContactMessages from "../components/AdminContactMessages";
import AdminWalletOverview from "../components/AdminWalletOverview";
import AdminRenewalHistory from "../components/AdminRenewalHistory";
import AdminTransferOwnership from "../components/AdminTransferOwnership";

/*
  Admin Panel shell.

  No separate password anymore — access is unlocked automatically for
  anyone already logged in to the main site (see adminLoginFromSession /
  admin_session_from_login.php). This still isn't a real role/permission
  system: every logged-in customer can open this. It only stops fully
  anonymous access (e.g. someone hitting the save endpoint directly with
  no login at all). Replace with a real `role`/`is_admin` check once that
  exists.

  Sections are listed in the sidebar so more Admin Panel items (page
  management, wallet, sub-domain summary, ownership transfer, service
  inquiries, bulk upload, leads/agents) can be added here later without
  restructuring this shell.
*/
export default function AdminPanel() {
    const [searchParams] = useSearchParams();
    const [token, setToken] = useState(getAdminToken());
    const [status, setStatus] = useState(token ? "ready" : "checking"); // checking | ready | denied
    const [section, setSection] = useState(searchParams.get("section") || "homepage-images");

    useEffect(() => {
        if (token) return; // already have a token from an earlier visit this session

        const localUser = JSON.parse(localStorage.getItem("user") || "{}");
        const personaluid = localUser?.personaluid;

        if (!personaluid) {
            setStatus("denied");
            return;
        }

        adminLoginFromSession(personaluid).then((res) => {
            if (res.success) {
                setToken(getAdminToken());
                setStatus("ready");
            } else {
                setStatus("denied");
            }
        });
    }, [token]);

    const handleLogout = () => {
        clearAdminToken();
        setToken("");
        setStatus("denied");
    };

    if (status === "checking") {
        return (
            <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
                Checking your login...
            </div>
        );
    }

    if (status === "denied") {
        return (
            <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh", background: "#f5f6f8" }}>
                <div className="card shadow-sm p-4 text-center" style={{ width: 340 }}>
                    <h5 className="fw-bold mb-2">Admin Panel</h5>
                    <p className="text-secondary small mb-3">Please log in to your DialNepal account first.</p>
                    <a className="btn btn-primary" href="/login">Go to Login</a>
                </div>
            </div>
        );
    }

    const sections = [
        ["homepage-images", "Homepage Images"],
        ["ad-leads", "Ad-Leads"],
        ["ad-segments", "Ad Segment"],
        ["become-agent", "Become Agent"],
        ["service-inquiries", "Service Inquiries"],
        ["page-management", "Page Management"],
        ["subdomains", "Sub-domains"],
        ["contact-messages", "Contact Messages"],
        ["wallet-overview", "Wallet Overview"],
        ["renewal-history", "Renewal History"],
        ["ownership-transfer", "Transfer Ownership"],
        // more sections land here as they're built:
        // ["wallet", "Wallet"],
    ];

    return (
        <div className="d-flex" style={{ minHeight: "100vh", background: "#f5f6f8" }}>
            <div className="bg-dark text-white p-3" style={{ width: 220, flexShrink: 0 }}>
                <h6 className="fw-bold mb-3">DialNepal Admin</h6>
                <ul className="nav flex-column">
                    {sections.map(([key, label]) => (
                        <li className="nav-item mb-1" key={key}>
                            <button
                                className={`btn btn-sm w-100 text-start ${section === key ? "btn-primary" : "btn-outline-light border-0"}`}
                                onClick={() => setSection(key)}
                            >
                                {label}
                            </button>
                        </li>
                    ))}
                </ul>
                <button className="btn btn-sm btn-outline-light mt-4" onClick={handleLogout}>Log out of Admin Panel</button>
            </div>
            {/* <div className="flex-grow-1 p-4" style={{ maxWidth: 980 }}>
                {section === "homepage-images" && <AdminHomepageImages />}
                {section === "ad-leads" && <AdminAdLeads />}
                {section === "ad-segments" && <AdminAdSegments />}
                {section === "become-agent" && <AdminBecomeAgent />}
                {section === "service-inquiries" && <AdminServiceInquiries />}
                {section === "page-management" && <AdminPageManagement />}
                {section === "subdomains" && <AdminSubdomains />}
                {section === "contact-messages" && <AdminContactMessages />}
                {section === "wallet-overview" && <AdminWalletOverview />}
                {section === "renewal-history" && <AdminRenewalHistory />}
                {section === "ownership-transfer" && <AdminTransferOwnership />}
            </div> */}
        </div>
    );
}
